<template>
  <v-container class="pa-0 pt-3" v-if="!isEmptyObject(service_options)">
    <v-divider class="pb-3"></v-divider>
    <div :key="idx" v-for="(option, idx) in service_options" class="pt-0 mt-n4">
      <v-checkbox :input-value="getServiceOptionValue(idx)" @change="commitServiceOptionValue($event, idx)"
        :label="option.frontend_message"
      ></v-checkbox>
    </div>
  </v-container>
</template>

<script>
  import {mapState} from 'vuex';
  export default {
    name: 'ServiceOptions',
    computed: {
      ...mapState('service_data', {
        service_options: state => state.selected.service_options,
      }),
    },
    methods: {
      isEmptyObject: (obj) => {
        return Object.keys(obj).length === 0 && obj.constructor === Object
      },
      getServiceOptionValue(idx) {
        return this.$store.state.additional_services[idx];
      },
      commitServiceOptionValue($event, idx) {
        this.$store.commit('additional_services/setServiceOption', { option: idx, selection: $event });
      }
    }

  }
</script>
<style scoped>
</style>
